module.exports = __webpack_public_path__ + "static/media/Hyderabad_Growth_API_Documentation.24b40eff.txt";